import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, Phone, X } from 'lucide-react';
import { Button } from '../ui/button';
import { CONTACT, NAV_LINKS } from './data';

export const Header = ({ overlay = false }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const toggleRef = useRef(null);
  const { pathname } = useLocation();
  const prefix = pathname === '/' ? '' : '/';
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    if (!overlay) return;
    const update = () => setScrolled(window.scrollY > 35);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [overlay]);
  useEffect(() => {
    if (!open) return;
    const close = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        toggleRef.current?.focus();
      }
    };
    document.addEventListener('keydown', close, true);
    return () => document.removeEventListener('keydown', close, true);
  }, [open]);
  return <header className={`site-header${overlay ? ' header-over-video' : ''}${scrolled ? ' is-scrolled' : ''}`} data-testid="site-header">
    <div className="nav-shell container">
      <Link to="/" aria-label="betaris Glanzwerk – Startseite" data-testid="nav-logo-link" className="brand-link">
        <img src="/images/betaris-logo.webp" alt="betaris Glanzwerk" width="176" height="82" />
      </Link>
      <nav aria-label="Hauptnavigation" className="desktop-nav">
        {NAV_LINKS.map(item => <a key={item.id} href={`${prefix}${item.href}`} data-testid={`nav-${item.id}-link`}>{item.label}</a>)}
      </nav>
      <div className="nav-actions">
        <a className="nav-phone" href={CONTACT.phoneHref} data-testid="nav-phone-link"><Phone size={15} />{CONTACT.phone}</a>
        <Button asChild className="nav-cta"><a href={`${prefix}#kontakt`} data-testid="nav-inquiry-link">Angebot anfragen<ArrowUpRight size={17} /></a></Button>
        <Button ref={toggleRef} variant="ghost" size="icon" className="mobile-toggle" data-testid="mobile-menu-toggle" aria-label={open ? 'Menü schließen' : 'Menü öffnen'} aria-expanded={open} aria-controls="mobile-navigation" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</Button>
      </div>
    </div>
    {open && <motion.nav id="mobile-navigation" aria-label="Mobile Navigation" data-testid="mobile-navigation" className="mobile-navigation" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} transition={{ duration: 0.2 }}>
      {NAV_LINKS.map(item => <a key={item.id} href={`${prefix}${item.href}`} data-testid={`mobile-${item.id}-link`} onClick={() => setOpen(false)}>{item.label}<ArrowUpRight size={20} /></a>)}
      <a href={`${prefix}#kontakt`} onClick={() => setOpen(false)} data-testid="mobile-contact-link">Kontakt<ArrowUpRight size={20} /></a>
      <a href={CONTACT.phoneHref} data-testid="mobile-phone-link"><Phone size={16} />{CONTACT.phone}</a>
    </motion.nav>}
  </header>;
};